var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 870,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: { span: 3 },
              wrapperCol: { span: 20 },
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _c(
              "a-form-model-item",
              { attrs: { label: "标题", prop: "title" } },
              [
                _c("a-input", {
                  attrs: { placeholder: "请输入标题" },
                  model: {
                    value: _vm.form.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "title", $$v)
                    },
                    expression: "form.title",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "方案分类", prop: "sort" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择方案分类",
                    dictCode: "group_counseling_sort",
                  },
                  model: {
                    value: _vm.form.sort,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "sort", $$v)
                    },
                    expression: "form.sort",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "详细介绍", prop: "evalWay" } },
              [
                _c("WangEditor", {
                  staticStyle: {
                    margin: "2px",
                    border: "1px solid #d9d9d9",
                    "border-radius": "4px",
                    overflow: "hidden",
                  },
                  attrs: { editorStyle: { minHeight: "300px" } },
                  model: {
                    value: _vm.form.content,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "content", $$v)
                    },
                    expression: "form.content",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }